namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailSchvalovaciSablonaEpk extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GSchvalovaciSablonaEpkReadDto;
        private newRecord: boolean;
        private detailObj: DetailSchvalovaciSablonaEpkObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailSchvalovaciSablonaEpkObj());
            this.detailObj.createBase({
                contentName: "detailSchvalovaciSablonaEpk",
                contentCaption: "jres:32131057",  //RC 33000887 : Skupina funkcí
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.getFunkceSchvalovaciSablonaEpkTab());
                tabs.push(this.detailObj.getSchvalovaciSablonaEpkUkonyTab());
                tabs.push(this.detailObj.getTypyDokumentuSchvalovaciSablonyEpkTab());
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.getFunkceSchvalovaciSablonaEpkGroup());
                groups.push(this.detailObj.getSchvalovaciSablonaEpkUkonyGroup());
                groups.push(this.detailObj.getTypyDokumentuSchvalovaciSablonyEpkGroup());
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailSchvalovaciSablonaEpk", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailSchvalovaciSablonaEpkObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GSchvalovaciSablonaEpkReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return `${this.data.ixs_ssa}`;
        }

        saveData(data: Gordic.AdmIsl.Interface.GSchvalovaciSablonaEpkSaveDto, close: boolean) {
            this.cnt.isl.SchvalovaciSablonaEpk.upsert({ data: data }).get().done((output: any) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderWflsssa");
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).catch((err) => {
                this.pendingAction("actSave", false)
                throw err;
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailSchvalovaciSablonaEpk", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.SchvalovaciSablonaEpk.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.data.nazev}`;
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                {
                    caption: "jres:33000138",
                    favorite: true,
                    icon: "fa-link",
                    visible: this.options.newRecord == false,
                    children: [
                        { action: this.cnt.actions.actSeznamFunkceSchvalovaciSablonaEpk },
                        { action: this.cnt.actions.actSeznamSchvalovaciSablonaEpkUkony },
                        { action: this.cnt.actions.actSeznamTypyDokumentuSchvalovaciSablonyEpk }
                    ]
                },
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actSeznamFunkceSchvalovaciSablonaEpk: {
                    icon: "fa-link",
                    caption: "jres:33000896", //RC 33000896 : Přiřazená funkční místa
                    visible: this.options.newRecord == false,
                    run: (ev, ctx) => {
                        this.openSeznamFunkceSchvalovaciSablonaEpk();
                    }
                }, 
                actSeznamSchvalovaciSablonaEpkUkony: {
                    icon: "fa-link",
                    caption: "jres:33000903",
                    visible: this.options.newRecord == false,
                    run: (ev, ctx) => {
                        this.openSeznamSchvalovaciSablonaEpkUkony();
                    }
                },
                actSeznamTypyDokumentuSchvalovaciSablonyEpk: {
                    icon: "fa-link",
                    caption: "jres:33000906",
                    visible: this.options.newRecord == false,
                    run: (ev, ctx) => {
                        this.openSeznamTypyDokumentuSchvalovaciSablonyEpk();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ekosico(), {
                model: "model.ico=value.ico",
                flag: this.createFlagNemenne()
            })
            this.MakeField("ixs_ssa", {
                flag: this.createFlagNemenne()
            });
            this.MakeField("nazev")
            this.MakeSelectField("ktg_typ", Gordic.Prefabs.Select.ginckat(), {
                model: "model.ktg_typ=value.ktg_typ"
            })
            this.MakeSelectField("var_proc", Gordic.Prefabs.Select.wflcvap(), {
                model: "model.ktg_typ=>value.ktg_typ;model.var_proc=value.var_proc",
                serverFilters: {
                    aktivita: null,
                    ktg_typ: new Gordic.Forms.Dependency("ktg_typ", "ktg_typ", true, false, this.cnt.element)
                },
            })
            this.MakeSelectField("stav_schvproc", Gordic.Prefabs.Select.wflsstp(), {
                model: "model.stav_schvproc=value.stav_schvproc",
            })
            this.MakeField("id_def_wwf")
            this.MakeSelectField("krg_rsp", Gordic.Prefabs.Select.wflckrs(), {
                model: "model.krg_rsp=value.krg_rsp",
            })
            this.MakeField("dat_od")
            this.MakeField("dat_do", { validators: [ this.getValidatorDatOdDo() ] })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        private openSeznamFunkceSchvalovaciSablonaEpk() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamFunkceSchvalovaciSablonyEpk", { ixs_ssa: this.data.ixs_ssa })
        }

        private openSeznamSchvalovaciSablonaEpkUkony() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamSchvalovaciSablonaEpkUkony", { ixs_ssa: this.data.ixs_ssa })
        }

        private openSeznamTypyDokumentuSchvalovaciSablonyEpk() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamTypyDokumentuSchvalovaciSablonyEpk", { ixs_ssa: this.data.ixs_ssa })
        }

        getFunkceSchvalovaciSablonaEpkTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-funkce-schvalovaci-sablony",
                    title: "jres:33000896", //RC 33000863 : Účtárny fun. místa
                    opened: true,
                    locked: true,
                    group: { id: "_tab-funkce-schvalovaci-sablony" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamFunkceSchvalovaciSablonyEpk",
                    serverParams: {
                        ID: "SeznamFunkceSchvalovaciSablonyEpk",
                        ixs_ssa: this.data.ixs_ssa,
                        tabOpen: true
                    }
                }
            }
        }

        getSchvalovaciSablonaEpkUkonyTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-schvalovaci-sablona-ukony",
                    title: "jres:33000903",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-schvalovaci-sablona-ukony" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamSchvalovaciSablonaEpkUkony",
                    serverParams: {
                        ID: "SeznamSchvalovaciSablonaEpkUkony",
                        ixs_ssa: this.data.ixs_ssa,
                        tabOpen: true
                    }
                }
            }
        }

        getTypyDokumentuSchvalovaciSablonyEpkTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-typy-dokumentu-schvalovaci-sablony",
                    title: "jres:33000906",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-typy-dokumentu-schvalovaci-sablony" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamTypyDokumentuSchvalovaciSablonyEpk",
                    serverParams: {
                        ID: "SeznamTypyDokumentuSchvalovaciSablonyEpk",
                        ixs_ssa: this.data.ixs_ssa,
                        tabOpen: true
                    }
                }
            }
        }

        getFunkceSchvalovaciSablonaEpkGroup(): IGTabGroupOptions {
            return { id: "_tab-funkce-schvalovaci-sablony", caption: "jres:33000896" }
        }

        getSchvalovaciSablonaEpkUkonyGroup(): IGTabGroupOptions {
            return { id: "_tab-schvalovaci-sablona-ukony", caption: "jres:33000903" }
        }

        getTypyDokumentuSchvalovaciSablonyEpkGroup(): IGTabGroupOptions {
            return { id: "_tab-typy-dokumentu-schvalovaci-sablony", caption: "jres:33000906" }
        }
    }
}